export default {
  items: [
    {
      name: 'Магазин виджетов',
      url: '/shop',
      icon: 'icon-basket',
    },
    {
      name: 'Личный кабинет',
      url: '/personal',
      icon: 'icon-user',
    },
    /*{
      name: `Баланс: 0р.`,
      url: '#',
      icon: 'cui-dollar',
      class: 'mt-auto',
      variant: 'success',
      attributes: { disabled: false },
    },*/
  ],
}